// extracted by mini-css-extract-plugin
export default {"container":"evos_container__aJYR2","evos_cards":"evos_evos_cards__FAhxW","img_container":"evos_img_container__RhHNt"};